<template>
    <true-panel class="aocPanel">
        <div class="aocPanel-topAction">
            <button @click="resetArea" v-if="!areaOfConcern.editing">
                <img src="/img/icon-undo.png" />
                <span>Start over</span>
            </button>
            <button @click="deleteArea(areaOfConcern)" v-if="areaOfConcern.editing" class="outline">
                <i class="fa fa-times-circle-o" />
                Remove area
            </button>
        </div>
        <header class="aocPanel-header">
            <div class="aocPanel-header-column"
                 :class="{'active': sectionIndex < 2}">1. Area Evaluation</div>
            <div class="aocPanel-header-column"
                 :class="{'active': sectionIndex > 1}">2. Security Options</div>
        </header>
        <div class="content-box-inner">
            
            <!-- One area is selected -->
            <div v-if="sectionIndex > 0"
                 class="aocSelected-header">
                <img :src="areaOfConcern.image" />
                <div class="aocSelected-title">{{ areaOfConcern.name }}</div>
                <div class="aocSelected-status"
                     v-if="areaOfConcern.name">
                    <!-- ACCESSIBILITY -->
                    <span v-if="areaOfConcern.accessibleFromGroundFloor === null">Accessibility</span>
                    <span v-if="areaOfConcern.accessibleFromGroundFloor !== null">
                                    <span v-if="areaOfConcern.accessibleFromGroundFloor">Accessible</span>
                    <span v-if="!areaOfConcern.accessibleFromGroundFloor">Not Accessible</span>
                    </span>

                    <span class="spacer">|</span>
                    <span v-if="!areaOfConcern.windows">Windows</span>
                    <span v-if="areaOfConcern.windows">
                                    <span v-if="!areaOfConcern.windowsThatOpen">
                                        {{ areaOfConcern.windows }} windows
                                    </span>
                    <span v-if="areaOfConcern.windowsThatOpen">
                                        {{ areaOfConcern.windowsThatOpen }}/{{ areaOfConcern.windows }} windows open
                                    </span>
                    </span>

                </div>
            </div>
            <slot />
        </div>
    </true-panel>
</template>


<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import Toasted from 'vue-toasted'
Vue.use(Toasted)

export default {
    computed: {
        ...mapState([
            'lead',
            'areaOfConcern',
            'availableAreas',
            'areaOfConcernSectionIndex',
            'emptyAreaOfConcern'
        ]),

        sectionIndex() {
            return this.areaOfConcernSectionIndex
        }
    },
    methods: {
        ...mapActions([
            'deleteAreaOfConcern',
            'updateAreaOfConcern',
            'setAocSectionIndex',
            'save'
        ]),

        deleteArea(area) {
            let areas = this.lead.areasOfConcern.filter(a => a.id !== area.id)
            this.$store.state.lead.areasOfConcern = areas
            this.updateAreaOfConcern(this.emptyAreaOfConcern)
            this.setAocSectionIndex(-1)
            this.save()
            let template = `
            <div class="toast-areaRemoved">
                <div class="toast-content">
                    <div><strong>${area.name} removed</strong></div>
                </div>
            </div>
        `

            Vue.toasted.show(template, {
                position: 'bottom-left',
                className: 'toast lightBlue',
                duration: 5000
            })
        },

        resetArea() {
            // Empty the local area of concern
            this.updateAreaOfConcern(this.emptyAreaOfConcern)
            this.setAocSectionIndex(-1)
        }
    }
}
</script>

<style lang="css"></style>
